import config from 'config';
import {
  FinalizeAdyenResponse,
  PrepareAdyenResp,
  UseAdyenCCPayPayload,
  UseAdyenCCPayResp,
} from 'types/transactions-cc';
import fetchWithToken from './provider/fetch';

const transactionsCCEndPoint = (accountKey: string, sessionId: string): string =>
  `${config.COPAS_URL}/payment/ui/cip/v2/${accountKey}/session/${sessionId}/transaction/cc`;

const transactionAdyenEndPoint = (accountKey: string, sessionId: string, paymentMethod: string): string =>
  `${config.COPAS_URL}/payment/ui/cip/v1/${accountKey}/session/${sessionId}/transaction/${paymentMethod}`;

// Prepare transaction
export const daoTransactionCcPreparePost = (accountKey: string, sessionId: string, data: object): Promise<object> =>
  fetchWithToken({
    reqUrl: `${transactionsCCEndPoint(accountKey, sessionId)}/prepare`,
    method: 'POST',
    body: JSON.stringify(data),
  });

// Prepare Adyen transaction
export const daoTransactionAdyenPreparePost = (
  accountKey: string,
  sessionId: string,
  data: object,
  paymentMethod: string,
): Promise<PrepareAdyenResp> =>
  fetchWithToken({
    reqUrl: `${transactionAdyenEndPoint(accountKey, sessionId, paymentMethod)}/prepare`,
    method: 'POST',
    body: JSON.stringify(data),
  });

// Finalize Adyen transaction
export const daoTransactionAdyenFinalizePost = (
  accountKey: string,
  sessionId: string,
  data: object,
  paymentMethod: string,
): Promise<FinalizeAdyenResponse> =>
  fetchWithToken({
    reqUrl: `${transactionAdyenEndPoint(accountKey, sessionId, paymentMethod)}/finalize`,
    method: 'POST',
    body: JSON.stringify(data),
  });

// Use stored credit card to pay
export const daoTransactionUseCcPayPost = (accountKey: string, sessionId: string, data: object): Promise<object> =>
  fetchWithToken({
    reqUrl: `${transactionsCCEndPoint(accountKey, sessionId)}/useStoredCreditCardWithPayment`,
    method: 'POST',
    body: JSON.stringify(data),
  });

export const daoTransactionUseCcPayScaPost = (accountKey: string, sessionId: string, data: object): Promise<object> =>
  fetchWithToken({
    reqUrl: `${transactionsCCEndPoint(accountKey, sessionId)}/useStoredCreditCardWithPayment/verifySca`,
    method: 'POST',
    body: JSON.stringify(data),
  });

// Use Adyen's stored credit card to pay
export const daoTransactionAdyenUseCcPayPost = (
  accountKey: string,
  sessionId: string,
  data: UseAdyenCCPayPayload,
): Promise<UseAdyenCCPayResp> =>
  fetchWithToken({
    reqUrl: `${transactionAdyenEndPoint(accountKey, sessionId, 'cca')}/stored/pay`,
    method: 'POST',
    body: JSON.stringify(data),
  });

export const daoTransactionAdyenUseCcPaySCAPost = (
  accountKey: string,
  sessionId: string,
  data: object,
): Promise<UseAdyenCCPayResp> =>
  fetchWithToken({
    reqUrl: `${transactionAdyenEndPoint(accountKey, sessionId, 'cca')}/stored/pay/verify`,
    method: 'POST',
    body: JSON.stringify(data),
  });

export default {
  daoTransactionCcPreparePost,
  daoTransactionAdyenPreparePost,
  daoTransactionAdyenFinalizePost,
  daoTransactionUseCcPayPost,
  daoTransactionUseCcPayScaPost,
};
